export default function Drawer(theme) {
	return {
		MuiDrawer: {
			styleOverrides: {
				paper: {},
			}
		}
	};
}
